import { fetchDataForItemPage } from '@/redux/modules/itemPage/itemPage.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { getIdFromPath, getNotFoundUrl } from '@/utils/urls';

export const itemPageData = async ({
    amplitudeExperimentFlags,
    location,
    match: { params },
    redirect,
    referrer,
    store: { dispatch },
}: DataLoaderParams) => {
    const itemId = getIdFromPath(params.itemId);

    if (!itemId) {
        return redirect(getNotFoundUrl());
    }

    // Always use new similar items for bots
    const useNewSimilarItems = true;
    // Scout categories should always be true for SSR
    const useScoutCategories = true;

    // Experiment: SEAR-893 Average Lot Value Re Ranking for Similar Lots
    const averageLotValueReRankingSimilarLotsVariant =
        amplitudeExperimentFlags[AmplitudeExperiments.AverageLotValueReRankingSimilarLots]?.value;
    const hasAverageLotValueReRankingSimilarLotsTreatment =
        averageLotValueReRankingSimilarLotsVariant === AmplitudeVariants.AverageLotValueReRankingSimilarLots.Treatment;

    return dispatch(
        fetchDataForItemPage({
            itemId,
            location,
            redirect,
            referrer,
            shouldUseSignalsBoost: hasAverageLotValueReRankingSimilarLotsTreatment,
            useNewSimilarItems,
            useScoutCategories,
        })
    );
};
